import { useNavigate } from 'react-router'
import styled from 'styled-components'

import { Button, Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { layoutHeightCss } from '@root/shared/ui-kit/utils/page-layout'

export const NotFoundPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Root>
      <Typography variant="h4">{t('common.page-not-found')}</Typography>
      <Button onClick={() => navigate('/')}>{t('common.go-home')}</Button>
    </Root>
  )
}

const Root = styled.div`
  ${layoutHeightCss}

  display: grid;
  justify-content: center;
  align-content: center;
  gap: 8px;
`
